

// var page = 1;
// var limit = 20;
// function slice(array, start, end) {
//   let length = array == null ? 0 : array.length
//   if (!length) {
//     return []
//   }
//   start = start == null ? 0 : start
//   end = end === undefined ? length : end

//   if (start < 0) {
//     start = -start > length ? 0 : (length + start)
//   }
//   end = end > length ? length : end
//   if (end < 0) {
//     end += length
//   }
//   length = start > end ? 0 : ((end - start) >>> 0)
//   start >>>= 0

//   let index = -1
//   const result = new Array(length)
//   while (++index < length) {
//     result[index] = array[index + start]
//   }
//   return result
// }
// var newDate = []
// function chunk(array, size = limit) {
//   const length = array == null ? 0 : array.length
//   if (!length || size < 1) {
//     return []
//   }
//   let index = 0;
//   let resIndex = 0;
//   const result = new Array(Math.ceil(length / size));

//   while (index < length) {
//     result[resIndex++] = slice(array, index, (index += size))
//   }
//   newDate = result
// }
// console.log(newDate)
// // var newDate = chunk(data.reverse(), limit);

// function createBox(page) {
//   var data = newDate[page];
//   var str = "";
//   for (var i = 0; i < data.length; i++) {
//     if (data[i]) {
//       str += "<div class='pic-box' data-index='" + (page*limit+ i) + "'><img src='" + data[i].imgUrl + "'><img class='bageIcon' src='//img.helloice.com/icon/lookbook-icon.png'></div>";
//     } else {
//       break;
//     }
//   }
//   $(".picture").append($(str));
// }

// createBox(page - 1);



function createPictureInfo(index, data=[]) {
  var numStr = '<img src="' + data[index].img + '">';
  var imgData = data[index].data;
  var proStr = "";
  for (var i = 0; i < imgData.length; i++) {
    const sku = imgData[i]['sku']
    numStr += '<div class="icon-num pic-icon" style="top:' + imgData[i].position[0] + '%;left:' + imgData[i].position[1] + '%;">' + (i + 1) + '</div>';
    proStr += '<li><a class="icon-num">' + (i + 1) + '</a>' +
      '<a href="'+sku['url']+'">' +
      '<div><div class="pro-name">'+sku['title']+'</div>' +
      '<div class="pro-img"><img src="'+sku['image']+'"></div>' +
      '<div class="pro-price prices">'+sku['price']+'</div><div class="pro-shop">SHOP NOW</div></div></a></li>';
    
  }
  $(".pic-info").html(numStr);
  $(".pro-info ul").html(proStr);
  $(".overlay").show();
}


// function scroll(e) {
//   var sum = document.body.scrollHeight;
//   var currot = $(this).scrollTop() + (window.innerHeight + 500);

//   if (sum <= currot) {
//     if (page < newDate.length) {
//       page++;
//       console.log(page);
//       createBox(page - 1);
//     }
//   }
// }

// function throttle(fn, delay) {
//   let valid = true
//   return function () {
//     if (!valid) {
//       return false
//     }
//     valid = false;
//     setTimeout(function () {
//       fn();
//       valid = true;
//     }, delay)
//   }
// }

// $(document).scroll(throttle(scroll, 500));

let newData = [],
    page = 1,
    limit = 10

function createBox(curPage) {
  var data = newData[curPage];
  var str = "";
  for (var i = 0; i < data.length; i++) {
    if (data[i]) {
      str += "<div class='i-item' data-index='" + (curPage*limit+ i) + "'><img src='" + data[i].img + "'><img class='bageIcon' src='//img.helloice.com/icon/lookbook-icon.png'></div>";
    } else {
      break;
    }
  }
  $(".icontainer .i-box").append($(str));
}
const loadIns = {
  init(data) {
    newData = this.chunk(data)
    createBox(page-1)
    this.eventScroll()
  },
  chunk(array, size = limit) {
    const length = array == null ? 0 : array.length
    if (!length || size < 1) {
      return []
    }
    let index = 0;
    let resIndex = 0;
    const result = new Array(Math.ceil(length / size));

    while (index < length) {
      result[resIndex++] = this.slice(array, index, (index += size))
    }
    return result
  },
  
  slice(array, start, end) {
    let length = array == null ? 0 : array.length
    if (!length) {
      return []
    }
    start = start == null ? 0 : start
    end = end === undefined ? length : end

    if (start < 0) {
      start = -start > length ? 0 : (length + start)
    }
    end = end > length ? length : end
    if (end < 0) {
      end += length
    }
    length = start > end ? 0 : ((end - start) >>> 0)
    start >>>= 0

    let index = -1
    const result = new Array(length)
    while (++index < length) {
      result[index] = array[index + start]
    }
    return result
  },
  scroll(e, that) {
    var sum = document.body.scrollHeight;
    var currot = $(this).scrollTop() + (window.innerHeight + 500);
    if (sum <= currot) {
      console.log(page)
      if (page < newData.length) {
        page++;
        createBox(page - 1);
      }
    }
  },
  throttle(fn, delay) {
  	let valid = true
    return function () {
      if (!valid) {
        return false
      }
      valid = false;
      setTimeout(function () {
        fn();
        valid = true;
      }, delay)
    }
  },
  eventScroll(){
    const throttle = this.throttle
    const scroll = this.scroll
  	$(document).scroll(throttle(scroll, 500));
  }
}